import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HubLogoModule } from '../hub-logo/hub-logo.module';
import { TrWrapperTwoColumnsModule } from '../tr-wrapper-two-columns/tr-wrapper-left-column.module';
import { PiNewPasswordFormComponent } from './pi-new-password-form.component';
import { TrSpinnerButtonDirectiveModule } from '../../directives';

@NgModule({
    imports: [
        CommonModule,
        TrWrapperTwoColumnsModule,
        HubLogoModule,
        ReactiveFormsModule,
        TrSpinnerButtonDirectiveModule,
    ],
    exports: [ PiNewPasswordFormComponent ],
    declarations: [ PiNewPasswordFormComponent ],
})
export class PiNewPasswordFormModule {}
